import DarkModeOutlined from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlined from '@mui/icons-material/LightModeOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectType } from 'redux/app/theme/theme.selectors';
import { themeActions } from 'redux/app/theme/theme.slice';

const ThemeSwitch = () => {
  const dispatch = useDispatch();
  const themeType = useSelector(selectType);
  const toggleTheme = () =>
    dispatch(themeActions.setType(themeType === 'light' ? 'dark' : 'light'));
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t('ThemeSwitch.tooltip', {
        onOff: themeType === 'light' ? 'off' : 'on',
      })}
      PopperProps={{ 'data-testid': 'ThemeSwitch.Tooltip' }}
    >
      <IconButton
        onClick={toggleTheme}
        data-testid="ThemeSwitch.IconButton"
        size="large"
      >
        {themeType === 'light' ? <DarkModeOutlined /> : <LightModeOutlined />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeSwitch;
